/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Settings = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <defs>
      <clipPath id="clip-path">
        <path
          id="Tracé_6381"
          data-name="Tracé 6381"
          d="M0,0H18V18H0Z"
          transform="translate(18.51 11.6)"
          fill="currentColor"
        />
      </clipPath>
    </defs>
    <g id="Groupe_de_masques_9" data-name="Groupe de masques 9" transform="translate(-18.51 -11.6)">
      <g id="options-sharp" transform="translate(16.434 9.523)">
        <path
          id="Tracé_6382"
          data-name="Tracé 6382"
          d="M16.5,4.846a2.077,2.077,0,0,0-3.916,0H2.077V6.231h10.5a2.077,2.077,0,0,0,3.916,0h3.581V4.846Z"
          fill="currentColor"
        />
        <path
          id="Tracé_6383"
          data-name="Tracé 6383"
          d="M7.615,9a2.081,2.081,0,0,0-1.958,1.385H2.077v1.385H5.657a2.077,2.077,0,0,0,3.916,0h10.5V10.385H9.573A2.081,2.081,0,0,0,7.615,9Z"
          fill="currentColor"
        />
        <path
          id="Tracé_6384"
          data-name="Tracé 6384"
          d="M14.538,14.538a2.081,2.081,0,0,0-1.958,1.385H2.077v1.385h10.5a2.077,2.077,0,0,0,3.916,0h3.581V15.923H16.5A2.081,2.081,0,0,0,14.538,14.538Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export { Settings };
